import report from '@/services/api/report';

export default {
  namespaced: true,
  state: {
    report: [],
  },
  getters: {
    report: state => state.report,
  },
  mutations: {},
  actions: {
    downloadListClient (state, { dateFrom, dateTo }) {
      return new Promise((resolve, reject) => {
        report.downloadListClient(dateTo, dateFrom)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    downloadSubscriber (state, { dateFrom, dateTo }) {
      return new Promise((resolve, reject) => {
        report.downloadSubscriber(dateTo, dateFrom)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    downloadApartmentForm (state) {
      return new Promise((resolve, reject) => {
        report.downloadApartmentForm()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    downloadFullReportFormDoorphone (state) {
      return new Promise((resolve, reject) => {
        report.downloadFullReportFormDoorphone()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    downloadServiceDoorCodeStats (state, { days }) {
      return new Promise((resolve, reject) => {
        report.downloadServiceDoorCodeStats(days)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    downloadPersonalAccountForm (state) {
      return new Promise((resolve, reject) => {
        report.downloadPersonalAccountForm()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    obtainingIndicatorsDoorphone (state) {
      return new Promise((resolve, reject) => {
        report.obtainingIndicatorsDoorphone()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getAbonentsStatistics (state) {
      return new Promise((resolve, reject) => {
        report.getAbonentsStatistics()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getMtoSectorIndicators (state) {
      return new Promise((resolve, reject) => {
        report.getMtoSectorIndicators()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getDeviceOfflineDailyStatistics (state, { dateFrom, dateTo } = {}) {
      return new Promise((resolve, reject) => {
        report.getDeviceOfflineDailyStatistics({ dateFrom, dateTo })
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getDeviceOfflineDailyStatisticsDevices (state, { date, type } = {}) {
      return new Promise((resolve, reject) => {
        report.getDeviceOfflineDailyStatisticsDevices({ date, type })
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getDoorphoneAdMetrics (state, { dateFrom, dateTo, cityId } = {}) {
      return new Promise((resolve, reject) => {
        report.getDoorphoneAdMetrics({ dateFrom, dateTo, cityId })
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    exportDoorphoneAdMetricsCsv (state, { dateFrom, dateTo, cityId, section } = {}) {
      return new Promise((resolve, reject) => {
        report.exportDoorphoneAdMetricsCsv({ dateFrom, dateTo, cityId, section })
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
  },
};
